import {
  Avatar,
  Backdrop,
  Box,
  Button,
  Grid,
  List,
  ListItem,
  Paper,
  Snackbar,
  Stack,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Typography,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import styles from "../../styles/pages/editors.module.scss";
// import assest from "@/json/assest";
import EditorsLargeModal from "../../ui/Modal/EditorsLargeModal";
import VideoIcon from "../../ui/Icons/VideoIcon";
import AnalyticsIcon from "../../ui/Icons/AnalyticsIcon";
import ProfileIcon from "../../ui/Icons/ProfileIcon";
import NotificationLeftFilter from "../NotificationLeftFilter/NotificationLeftFilter";
import HomeIcon from "../../ui/Icons/HomeIcon";
import LongArrowIcon from "../../ui/Icons/LongArrowIcon";
import DuplicateIcon from "../../ui/Icons/DuplicateIcon";
import TabArrowIcon from "../../ui/Icons/TabArrowIcon";
import Pagination from "../UtilitiesComponent/Pagination";
import assest from "../../json/assest";
import RoundCheckIcon from "../../ui/Icons/RoundCheckIcon";
import RoundTickIcon from "../../ui/Icons/RoundTickIcon";
import ManagerConfirmedWebsiteTable from "../ManagersModalTable/ManagerConfirmedWebsiteTable";
import ManagerConfirmedApprovedApprovedTable from "../ManagersModalTable/ManagerConfirmedApprovedApprovedTable";
import ManagerConfirmedRejectTable from "../ManagersModalTable/ManagerConfirmedRejectTable";
import ManagerDeniedApprovedRejectedTable from "../ManagersModalTable/ManagerDeniedApprovedRejectedTable";
import ManagerDeniedApprovedWebsiteTable from "../ManagersModalTable/ManagerDeniedApprovedWebsiteTable";
import ManagerDeniedRejectedApprovedTable from "../ManagersModalTable/ManagerDeniedRejectedApprovedTable";
import ManagerDeniedRejectedWebsiteTable from "../ManagersModalTable/ManagerDeniedRejectedWebsiteTable";
import ManagerDeniedWebsiteApprovedTable from "../ManagersModalTable/ManagerDeniedWebsiteApprovedTable";
import ManagerDeniedWebsiteRejectedTable from "../ManagersModalTable/ManagerDeniedWebsiteRejectedTable";
import ManagersDuplicateVideoTable from "../ManagersModalTable/ManagersDuplicateVideoTable";
import ManagersModalTable from "../ManagersModalTable/ManagersModalTable";
// import ModaltableHeader from "../../components/ModaltableHeader/ModaltableHeader";
import AssignRadioCard from "../AssignRadioCard/AssignRadioCard";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import InfomarkIcon from "../../ui/Icons/InfomarkIcon";
import WebsiteIcon from "../../ui/Icons/WebsiteIcon";
import NOprofileImage from "../../public/assets/images/no-image.svg";

// import TipaltiPartnerCard from ".";

import { useMutation, useQuery, useQueryClient } from "react-query";
import TipaltiPartnerCard from "../TipaltiPartnerCard/TipaltiPartnerCard";
import {
  concatHostAndImagePath,
  emptyHandleTwo,
  getStartEndDateTwo,
  getStyledShortDate,
} from "../../lib/functions/utils.lib";
import {
  getManagerCardSubmission,
  getManagerVideos,
  managerAssignUnassignList,
  managerCardProfile,
} from "../../api/functions/manager.api";
// import EmptyTable from "../EmptyTable/EmptyTable";
// import ApiLoader from "../Loaders/ApiLoader";
import { submissionsList } from "../../api/functions/cms.api";
import ManagerUserCreateTab from "../UserCreateTab/ManagerUserCreateTab";
import {
  setPage,
  setHasNote,
  setUnreachableSubmitter,
  setHasMessage,
  setMonth,
  setYear,
  setSubmitPlace,
  setUserId,
  setManagerId,
  // setQualityTeamId,
  setPeopleAppearing,
  setPersonWhoFilmed,
  setSubmitOtherWebsite,
  setAgreementWithAnotherCompany,
  setFrom,
  setTo,
  setDuplicates,
  managerdateFormat,
} from "../../redux-toolkit/slices/managerConfirmedApprovedApproved.slice";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { ProfileUpdateMutation } from "../../api/functions/user.api";
import NewbookmarkIcon from "../../public/assets/icons/NewbookmarkIcon";
import { usePost } from "../../hooks/api/useFetch";
import SelectMonth from "../SelectMonth/SelectMonth";
import SelectYear from "../SelectYear/SelectYear";
import VideosummaryCardPartner from "../VideosummaryCard/VideosummaryCardPartner";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManagerCard = (props) => {
  // console.warn("🚀 ~ file: SearchEditorCard.jsx:115 ~ propsadsda:", props);
  const [openEditorsLargeModal, setOpenEditorsLargeModal] =
    React.useState(false);

  const queryClient = useQueryClient();

  const handleOpenCommonModal = useCallback(() => {
    {
      props?.cardType === "info"
        ? setOpenEditorsLargeModal(true)
        : props?.cardType === "for_copywriter"
        ? setOpenCopywritterLargeModal(true)
        : props?.cardType === "for_qc"
        ? setOpenQcLargeModal(true)
        : props?.cardType === "for_manager"
        ? setOpenManagerLargeModal(true)
        : null;
    }
  }, [openEditorsLargeModal]);

  const handleCloseEditorsLargeModal = useCallback(() => {
    setOpenEditorsLargeModal(false);
  }, []);

  const [openCopywritterLargeModal, setOpenCopywritterLargeModal] =
    React.useState(false);

  const handleCloseCopywritterLargeModal = useCallback(() => {
    setOpenCopywritterLargeModal(false);
  }, []);

  const [openQcLargeModal, setOpenQcLargeModal] = React.useState(false);

  const handleCloseQcLargeModal = useCallback(() => {
    setOpenQcLargeModal(false);
  }, []);

  const [openManagerLargeModal, setOpenManagerLargeModal] =
    React.useState(false);

  const handleCloseManagerLargeModal = useCallback(() => {
    setOpenManagerLargeModal(false);
  }, []);

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [innerTab, setInnerTab] = React.useState(0);

  const handleChange2 = (event, newValue) => {
    setInnerTab(newValue);
  };

  const [dinedTab, setdinedTab] = React.useState(0);

  const handleChange3 = (event, newValue) => {
    setdinedTab(newValue);
  };

  const [confimvdoTab, setConfimvdoTab] = React.useState(0);
  const handleChange4 = (event, newValue) => {
    setConfimvdoTab(newValue);
  };

  const [deniedvdoTab, setdeniedvdoTab] = React.useState(0);

  const handleChange5 = (event, newValue) => {
    setdeniedvdoTab(newValue);
  };

  const [snackOpen, setSnackOpen] = React.useState(false);
  const [snackOpen1, setSnackOpen1] = React.useState(false);

  // const [index, setIndex] = useState("1");

  const handlepageNo = (index) => {
    // setIndex();
  };
  // console.warn(props.type);

  // const handleClose = (
  //   event: React.SyntheticEvent | Event,
  //   reason
  // ) => {
  //   if (reason === "clickaway") {
  //     return;
  //   }

  //   setSnackOpen(false);
  // };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackOpen(false);
  };

  const handleClose1 = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackOpen1(false);
  };

  // const handleClose1 = (
  //   event: React.SyntheticEvent | Event,
  //   reason
  // ) => {
  //   if (reason === "clickaway") {
  //     return;
  //   }

  //   setSnackOpen1(false);
  // };
  const [page, setPage] = useState(1);

  const handleDataFromChild = (e) => {
    setPage(e);
    // Do something with the data received from the child component
  };
  // const [date, setDate] = useState("");
  const [date, setDate] = useState({ startDate: "", endDate: "" });
  const getDataFromChild = (date) => {
    // console.warn(date);
    setDate(date);
  };

  const [startDate, setStartDate] = React.useState({
    month: "",
    year: "",
  });
  const handleChildData = (anchorEl) => {
    if (anchorEl.month) {
      setStartDate({ ...startDate, month: anchorEl.month });
    } else if (anchorEl.year) {
      setStartDate({ ...startDate, year: anchorEl.year });
    }
  };
  // useEffect(()=>{
  //   props.getDateFromThisCompo(date)
  // }, [date])
  /*   const [managerCardSubmissionData, setManagerCardSubmissionData] = useState(
    {}
  );
  const { mutate: mutating } = useMutation(getManagerCardSubmission);

  useEffect(() => {
    const managerId = {
      manager_id: props?.id,
      from: date?.startDate,
      to: date?.endDate,
    };
    mutating(managerId, {
      onSuccess: (data) => {
        // console.warn(data, "managerId")
        setManagerCardSubmissionData(data);
      },
    });
  }, [date, props?.id]);
 */
  const {
    data: managerCardSubmissionData,
    refetch: managerCardSubmissionRefetch,
  } = usePost(
    [
      "managerCardSubmission",
      props?.id,
      date?.startDate,
      date?.endDate,
      startDate?.month,
      startDate?.year,
    ],
    `admin/submissions?manager_id=${props?.id ? props?.id : "0"}&from=${
      startDate?.month || startDate?.year
        ? getStartEndDateTwo(startDate?.month, startDate?.year).start_date
        : date?.startDate
    }&to=${
      startDate?.month || startDate?.year
        ? getStartEndDateTwo(startDate?.month, startDate?.year).end_date
        : date?.endDate
    }`
  );

  // const { data: VIDEOList, isLoading } = useQuery(
  //   ["VIDEOList", props.selectedId, page],

  //   async () => {
  //     return EditorVIDEOMutation({ editor_id: props.selectedId, page: page });
  //   }
  // );
  // console.warn("🚀 ~ file: SearchEditorCard.jsx:243 ~ VIDEOList:", VIDEOList);

  // const [managerVideoPage, setManagerVideoPage] = useState(1);
  // const [managerDecision, setManagerDecision] = useState("");
  // const [qualityTeamDecision, setQualityTeamDecision] = useState("");
  // const [duplicateStatus, setDuplicateStatus] = useState("");
  // console.warn(managerVideoPage);
  // const { data, isLoading: isLoading2 } = useQuery(
  //   [
  //     "fetchVideosOfManager",
  //     managerVideoPage,
  //     props?.selectedId,
  //     qualityTeamDecision,
  //     managerDecision,
  //     duplicateStatus,
  //   ],
  //   () =>
  //   console.warn("fjdn")
  //     getManagerVideos({
  //       managerId: props?.selectedId,
  //       page: managerVideoPage,
  //       manager_decision: managerDecision,
  //       quality_team_decision: qualityTeamDecision,
  //       duplicateStatus: duplicateStatus,
  //     })
  // );
  const { data: manager, refetch } = useQuery(
    ["getSelectedManager".props?.selectedId],
    () => managerCardProfile(props?.selectedId),
    {
      enabled: false,
    }
  );
  // console.warn(manager?.data?.permissions);
  // const permissionApiArray = manager?.data?.permissions;
  const permissionApiArray = manager?.data?.permissions || [];
  const filteredPermissionArray = permissionApiArray.filter(
    (item) => item !== ""
  );

  // console.warn("filteredPermissionArray:", filteredPermissionArray);

  const { mutate } = useMutation(managerAssignUnassignList);
  const [assignUnassignList, setAssignUnassignList] = useState();
  useEffect(() => {
    const managerId = { manager_id: props?.id };
    mutate(managerId, {
      onSuccess: (data) => {
        setAssignUnassignList(data);
      },
    });
  }, [props?.id]);

  // console.warn(data?.data, "managerVideos");
  const [assignRadio, setAssignRadio] = useState([]);
  const [unassignRadio, setUnassignRadio] = useState([]);
  const [clicked, setClicked] = useState(false);

  const getAssignData = (d) => {
    // console.warn(d)
    if (assignRadio.includes("")) {
      let x = assignRadio.indexOf("");
      assignRadio.splice(x, 1);
      unassignRadio.splice(x, 1);
    }
    setAssignRadio([...assignRadio, d]);

    if (assignRadio.includes(d)) {
      let y = assignRadio.indexOf(d);
      assignRadio.splice(y, 1);
      setAssignRadio([...assignRadio]);
    }
  };
  // console.warn(assignRadio, "assignRadio");

  const filteredArray = Array.isArray(filteredPermissionArray)
    ? filteredPermissionArray?.filter((item) => !assignRadio.includes(item))
    : "";

  // console.warn(filteredArray, "radio");

  const getUnassignData = (d) => {
    // console.warn(d)
    if (unassignRadio.includes("")) {
      let a = unassignRadio.indexOf("");
      unassignRadio.splice(a, 1);
      assignRadio.splice(a, 1);
    }
    setUnassignRadio([...unassignRadio, d]);

    if (unassignRadio.includes(d)) {
      let b = unassignRadio.indexOf(d);
      unassignRadio.splice(b, 1);
      setUnassignRadio([...unassignRadio]);
    }
  };

  // console.warn(unassignRadio, "unassignRadio", unassignRadio?.length);
  const newUnassignArray = unassignRadio.concat(filteredPermissionArray);
  // console.warn(newUnassignArray, "newUnassignArray");

  const { mutate: profilePermissionUpdate } = useMutation(
    ProfileUpdateMutation
  );

  const handleClick = () => {
    if (assignRadio.includes("")) {
      let x = assignRadio.indexOf("");
      assignRadio.splice(x, 1);
    }
    if (assignRadio.length >= 1) {
      const permissions = filteredArray.join(",");
      const formdata = new FormData();
      /* filteredArray.map((item) => {
        formdata.append("permissions[]", item);
      }); */
      formdata.append("permissions", permissions);
      formdata.append("user_id", props?.selectedId);
      profilePermissionUpdate(formdata, {
        onSuccess: (data) => {
          // console.warn(data);
          const managerId = { manager_id: props?.id };
          mutate(managerId, {
            onSuccess: (data) => {
              setAssignUnassignList(data);
              setClicked(true);
              setAssignRadio([]);
              queryClient.invalidateQueries(["fetchManagerList"]);
            },
          });
          setSnackOpen(true);
        },
      });
    }
  };

  const handleCancel = () => {
    setAssignRadio([]);
    setClicked(true);
  };

  const handleClick1 = () => {
    if (unassignRadio.includes("")) {
      let x = unassignRadio.indexOf("");
      unassignRadio.splice(x, 1);
    }
    if (unassignRadio.length >= 1) {
      const permissions = newUnassignArray.join(",");
      // console.warn("permissions", permissions);
      const formdata = new FormData();
      /* newUnassignArray.map((item) => {
           formdata.append("permissions[]", item);
         });  */
      formdata.append("permissions", permissions);
      formdata.append("user_id", props?.selectedId);
      profilePermissionUpdate(formdata, {
        onSuccess: (data) => {
          // console.warn(data);
          const managerId = { manager_id: props?.id };
          mutate(managerId, {
            onSuccess: (data) => {
              setAssignUnassignList(data);
              setClicked(true);
              setUnassignRadio([]);
              queryClient.invalidateQueries(["fetchManagerList"]);
            },
          });
          setSnackOpen1(true);
        },
      });
    }
  };
  const handleCancel1 = () => {
    // console.warn("Cancel button clicked");
    setUnassignRadio([]);
    setClicked(true);
  };

  const dispatch = useAppDispatch();
  const filterReset = () => {
    dispatch(setHasNote(null));
    dispatch(setFrom("2021-01-01"));
    dispatch(setTo(managerdateFormat));
    dispatch(setSubmitPlace(null));
    dispatch(setUserId(null));
    dispatch(setMonth(null));
    dispatch(setYear(null));
    dispatch(setDuplicates(null));
    dispatch(setHasMessage(null));
    dispatch(setUnreachableSubmitter(null));
    dispatch(setPeopleAppearing(null));
    dispatch(setPersonWhoFilmed(null));
    dispatch(setSubmitOtherWebsite(null));
    dispatch(setAgreementWithAnotherCompany(null));
    setStartDate({
      month: "",
      year: "",
    });
  };

  // const { data: submissionsListData } = useQuery(
  //   ["submissionsList", props.selectedId],
  //   async () =>
  //     submissionsList({
  //       editor_id: props.selectedId,
  //     })
  // );
  // console.warn(
  //   "🚀 ~ file: SearchCopywriterCard.jsx:694 ~ SearchCopywriterCard ~ submissionsListData:",
  //   submissionsListData?.data?.video_publishing
  // );

  // console.warn(assignUnassignList);
  // console.warn(props, "avatarx");
  return (
    <>
      <Paper
        className={styles.srchCardPaper}
        onClick={() => handleOpenCommonModal()}
      >
        <Stack
          direction={"row"}
          flexWrap={"wrap"}
          className={styles.cardgrid}
          onClick={props?.onClick}
        >
          {props?.avatar === "users/default.png" ? (
            <Avatar
              alt="Viral Snare"
              src={NOprofileImage}
              sx={{ width: 52, height: 52 }}
            />
          ) : (
            <Avatar
              alt="Viral Snare"
              src={concatHostAndImagePath(props?.avatar)}
              sx={{ width: 52, height: 52 }}
            />
          )}
          <Box className={styles.userDetails}>
            <List>
              <ListItem>
                <Typography variant="h3">{props?.name}</Typography>
              </ListItem>

              <ListItem>
                <Typography
                  variant="body1"
                  className={`${styles.textSince} ${
                    props?.editorDate ? "" : styles.pendingInvition
                  }`}
                >
                  {/* {props?.sinceTitle} */}
                  Manager since:
                  <span>
                    {props?.editorDate
                      ? getStyledShortDate(props?.editorDate)
                      : `(Pending invitation)`}
                  </span>
                </Typography>
              </ListItem>
              <ListItem className={styles.copywriterCardEmail}>
                <Typography variant="body1">
                  Email Address:
                  <span>{props?.email}</span>
                </Typography>
              </ListItem>
              {props?.assignAccount && (
                <ListItem>
                  <Typography variant="body1">
                    Assigned Accounts:
                    <span>{props?.assignNo}</span>
                  </Typography>
                </ListItem>
              )}
              <ListItem>
                <Typography variant="body1">
                  {props?.videoFor} Videos:{" "}
                  <span>{emptyHandleTwo(props?.totalVideo)}</span>
                </Typography>
              </ListItem>
            </List>
            {props.cardType === "for_qc" ? (
              <Box className={styles.cardAlert}>
                <Stack
                  direction={"row"}
                  alignItems={"center"}
                  flexWrap={"wrap"}
                  className={`${styles.textDenied} ${styles.stackStyled}`}
                >
                  <img
                    src={assest.iconDenied}
                    width={16}
                    height={16}
                    alt="icon"
                  />
                  <Typography variant="body1">
                    Denied Decisions: <span>450</span>
                  </Typography>
                </Stack>
                <Stack
                  direction={"row"}
                  alignItems={"center"}
                  flexWrap={"wrap"}
                  className={`${styles.textConfirm} ${styles.stackStyled}`}
                >
                  <img
                    src={assest.iconConfirm}
                    width={16}
                    height={16}
                    alt="icon"
                  />
                  <Typography variant="body1">
                    Confirmed Decisions: <span>450</span>
                  </Typography>
                </Stack>
              </Box>
            ) : null}
          </Box>
          {props?.type === 1 ? (
            <Box className={`${styles.resultStatus} ${styles.success}`}>
              Active
            </Box>
          ) : props?.type === 0 ? (
            <Box className={`${styles.resultStatus} ${styles.inactive}`}>
              Inactive
            </Box>
          ) : null}
        </Stack>
        {props?.assignAccount && (
          <Stack
            direction={"row"}
            flexWrap={"wrap"}
            alignItems={"center"}
            className={styles.videoOption}
          >
            {/* {videoOptioncard.map((option) => {
                return (
                  <Paper elevation={0} className={styles.optionRowList}>
                    <figure>{option?.cardIcon}</figure>
                    <Box className={styles.queryRight}>
                      <Typography variant="body1">{option?.title}</Typography>
                      <Typography variant="caption">{option?.cardNo}</Typography>
                    </Box>
                  </Paper>
                );
              })} */}
            <Paper elevation={0} className={styles.optionRowList}>
              <figure>
                <InfomarkIcon />
              </figure>
              <Box className={styles.queryRight}>
                <Typography variant="body1">{"Inquiring videos"}</Typography>
                <Typography variant="caption">
                  {emptyHandleTwo(props?.inquiringVideos)}
                </Typography>
              </Box>
            </Paper>
            <Paper elevation={0} className={styles.optionRowList}>
              <figure>
                <RoundCheckIcon />
              </figure>
              <Box className={styles.queryRight}>
                <Typography variant="body1">{"Approved videos"}</Typography>
                <Typography variant="caption">
                  {emptyHandleTwo(props?.approvedVideos)}
                </Typography>
              </Box>
            </Paper>
            <Paper elevation={0} className={styles.optionRowList}>
              <figure>
                <WebsiteIcon />
              </figure>
              <Box className={styles.queryRight}>
                <Typography variant="body1">{"Website only"}</Typography>
                <Typography variant="caption">
                  {emptyHandleTwo(props?.website_onlyVideos)}
                </Typography>
              </Box>
            </Paper>
            <Paper elevation={0} className={styles.optionRowList}>
              <figure>
                <RoundTickIcon />
              </figure>
              <Box className={styles.queryRight}>
                <Typography variant="body1">{"Rejected videos"}</Typography>
                <Typography variant="caption">
                  {emptyHandleTwo(props?.rejectedVideos)}
                </Typography>
              </Box>
            </Paper>
          </Stack>
        )}
      </Paper>

      <EditorsLargeModal
        open={openManagerLargeModal}
        onClose={handleCloseManagerLargeModal}
      >
        <Stack
          direction={"row"}
          alignItems={"center"}
          flexWrap={"wrap"}
          className={styles.editorModalHeader}
        >
          <Stack
            direction={"row"}
            alignItems={"center"}
            flexWrap={"wrap"}
            className={styles.PfMediaBody}
          >
            {props?.avatar === "users/default.png" ? (
              <Avatar
                alt="Viral Snare"
                src={NOprofileImage}
                sx={{ width: 52, height: 52 }}
              />
            ) : (
              <Avatar
                alt="Viral Snare"
                src={concatHostAndImagePath(props?.avatar)}
                sx={{ width: 52, height: 52 }}
              />
            )}
            <Box className={styles.profileMediaRight}>
              <Typography variant="body1">{props?.name}</Typography>
              <Typography variant="caption">{props?.displayName}</Typography>
            </Box>
          </Stack>
          <Stack className={styles.tabsFlex}>
            <Box className={`${styles.scrollTabs} ${styles.managerScrollTabs}`}>
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="basic tabs example"
                className={styles.tabsMain}
              >
                <Tab
                  icon={
                    <span>
                      <HomeIcon />
                    </span>
                  }
                  iconPosition="start"
                  label="Home"
                  {...a11yProps(0)}
                />
                <Tab
                  // onClick={()=>{
                  //   setManagerDecision("3");
                  //   setQualityTeamDecision("");
                  //   setManagerVideoPage("1");
                  //   setDuplicateStatus("");
                  //   setInnerTab(0)
                  // }}
                  onClick={() => filterReset()}
                  icon={
                    <span>
                      <VideoIcon />
                    </span>
                  }
                  iconPosition="start"
                  label="Reviewed Submissions"
                  {...a11yProps(1)}
                />
                <Tab
                  onClick={() => refetch()}
                  icon={
                    <span>
                      <NewbookmarkIcon />
                    </span>
                  }
                  iconPosition="start"
                  label="Assigned Accounts"
                  {...a11yProps(2)}
                />
                <Tab
                  onClick={() => filterReset()}
                  icon={
                    <span>
                      <AnalyticsIcon />
                    </span>
                  }
                  iconPosition="start"
                  label="Analytics"
                  {...a11yProps(3)}
                />
                <Tab
                  onClick={() => filterReset()}
                  icon={
                    <span>
                      <ProfileIcon />
                    </span>
                  }
                  iconPosition="start"
                  label="Profile"
                  {...a11yProps(4)}
                />
              </Tabs>
            </Box>
          </Stack>
          <Box className={styles.closeDialogOuter}>
            <Button onClick={handleCloseManagerLargeModal}>
              <img src={assest.crossGray} width={13} height={13} alt="icon" />
            </Button>
          </Box>
        </Stack>
        <Box className={styles.tabPanelWrap}>
          {/* <PerfectScrollbar> */}
          <TabPanel value={value} index={0}>
            <Box
              className={`${styles.tabHomeContainer} ${styles.managerModalHome}`}
            >
              <Stack
                direction={"row"}
                flexWrap={"wrap"}
                alignItems={"center"}
                className={styles.viewDateStack}
              >
                <Typography variant="body1">View data for</Typography>
                <Stack
                  direction={"row"}
                  flexWrap={"wrap"}
                  alignItems={"center"}
                  className={`${styles.showmonthyear} monthData`}
                >
                  {/* <Typography variant="caption" className={styles.monthFor}>
                    Month
                  </Typography>
                  <Typography variant="caption" className={styles.yearFor}>
                    Year
                  </Typography> */}
                  <SelectMonth sendDataToParent={handleChildData} />
                  <SelectYear sendDataToParent={handleChildData} />
                </Stack>
              </Stack>
              <Box
                className={`${styles.tabHomeCardGroup} ${styles.managerCardGroup}`}
              >
                <Grid
                  container
                  rowSpacing={0}
                  columnSpacing={{ xs: 1, sm: 2, md: 6.25 }}
                >
                  {/* {cardGridLoopforManager.map((item, index) => {
                      return ( */}
                  <Grid item md={6}>
                    <VideosummaryCardPartner
                      videoTitle={"Reviewing Summary"}
                      countVideo={""}
                    >
                      <List>
                        {/* {item.children.map((subItem) => {
                                return ( */}
                        <ListItem>
                          <Typography variant="body1">
                            All videos
                            {/* {subItem?.listName} */}
                          </Typography>
                          <Typography variant="caption">
                            {emptyHandleTwo(
                              managerCardSubmissionData?.data?.data
                                ?.all_submissions?.total
                            )}
                            {/* {subItem?.videoCount} */}
                          </Typography>
                        </ListItem>
                        <ListItem>
                          <Typography variant="body1">
                            Website-only videos
                          </Typography>
                          <Typography variant="caption">
                            {emptyHandleTwo(
                              managerCardSubmissionData?.data?.data
                                ?.all_submissions?.website_only
                            )}
                          </Typography>
                        </ListItem>

                        <ListItem>
                          <Typography variant="body1">
                            All-platform videos
                          </Typography>
                          <Typography variant="caption">
                            {emptyHandleTwo(
                              managerCardSubmissionData?.data?.data
                                ?.all_submissions?.approved
                            )}
                          </Typography>
                        </ListItem>
                        <ListItem>
                          <Typography variant="body1">
                            Duplicate videos
                          </Typography>
                          <Typography variant="caption">
                            {emptyHandleTwo(
                              managerCardSubmissionData?.data?.data
                                ?.all_submissions?.duplicate_videos
                            )}
                          </Typography>
                        </ListItem>
                        <ListItem>
                          <Typography variant="body1">
                            Rejected videos
                          </Typography>
                          <Typography variant="caption">
                            {emptyHandleTwo(
                              managerCardSubmissionData?.data?.data
                                ?.all_submissions?.rejected
                            )}
                          </Typography>
                        </ListItem>
                        {/* );
                              })} */}
                      </List>
                      <img
                        src={assest.submissionSummeryImg}
                        width={36}
                        height={36}
                        alt=""
                        className={styles.watermark}
                      />
                    </VideosummaryCardPartner>
                  </Grid>
                  <Grid item md={6}>
                    <VideosummaryCardPartner
                      videoTitle={"Validation Summary"}
                      countVideo={""}
                    >
                      <List>
                        {/* {item.children.map((subItem) => {
                                return ( */}
                        <ListItem>
                          <Typography variant="body1">Confirmed</Typography>
                          <Typography variant="caption">
                            {emptyHandleTwo(
                              managerCardSubmissionData?.data?.data
                                ?.confirmed_videos?.total
                            )}
                          </Typography>
                        </ListItem>
                        <ListItem>
                          <Typography variant="body1">Denied</Typography>
                          <Typography variant="caption">
                            {emptyHandleTwo(
                              managerCardSubmissionData?.data?.data?.denied
                                ?.total
                            )}
                          </Typography>
                        </ListItem>
                        {/* );
                              })} */}
                      </List>
                      <img
                        src={assest.submissionSummeryImg}
                        width={36}
                        height={36}
                        alt=""
                        className={styles.watermark}
                      />
                    </VideosummaryCardPartner>
                  </Grid>
                  {/* );
                    })} */}
                </Grid>
              </Box>
            </Box>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Box className={styles.fluidSec}>
              <Box className="grouptabBtn">
                <Tabs
                  value={innerTab}
                  onChange={handleChange2}
                  aria-label="basic tabs example"
                >
                  <Tab
                    // onClick={() => {
                    //   setManagerDecision("3");
                    //   setQualityTeamDecision("");
                    //   setManagerVideoPage("1");
                    //   setDuplicateStatus("");
                    // }}
                    onClick={() => filterReset()}
                    label={
                      <>
                        <Stack
                          direction={"row"}
                          alignItems={"center"}
                          flexWrap={"wrap"}
                          className="tabBtnWrapper"
                        >
                          <figure>
                            <InfomarkIcon />
                          </figure>
                          <Box className="queryRight">
                            <Typography variant="body1">
                              Inquiring Videos
                            </Typography>
                            <Typography variant="caption">
                              {emptyHandleTwo(
                                managerCardSubmissionData?.data?.data
                                  .all_submissions?.inquiry
                              )}
                            </Typography>
                          </Box>
                        </Stack>
                      </>
                    }
                    {...a11yProps(5)}
                    className="btninquringVideo"
                  />
                  <Tab
                    // onClick={() => {
                    //   // setManagerVideoPage("1")
                    //   setManagerDecision("1");
                    //   setQualityTeamDecision("1");
                    //   setDuplicateStatus("");
                    //   setConfimvdoTab(0)
                    // }}
                    onClick={() => filterReset()}
                    label={
                      <>
                        <Stack
                          direction={"row"}
                          alignItems={"center"}
                          flexWrap={"wrap"}
                          className="tabBtnWrapper"
                        >
                          <figure>
                            <RoundCheckIcon />
                          </figure>
                          <Box className="queryRight">
                            <Typography variant="body1">
                              Confirmed videos
                            </Typography>
                            <Typography variant="caption">
                              {emptyHandleTwo(
                                managerCardSubmissionData?.data?.data
                                  .confirmed_videos?.total
                              )}
                            </Typography>
                          </Box>
                        </Stack>
                      </>
                    }
                    {...a11yProps(6)}
                    className="btnconfirmVideo"
                  />
                  <Tab
                    // onClick={() => {
                    //   // setManagerVideoPage("1")
                    //   setManagerDecision("1");
                    //   setQualityTeamDecision("2");
                    //   setDuplicateStatus("");
                    //   setdeniedvdoTab(0)
                    // }}
                    onClick={() => filterReset()}
                    label={
                      <>
                        <Stack
                          direction={"row"}
                          alignItems={"center"}
                          flexWrap={"wrap"}
                          className="tabBtnWrapper"
                        >
                          <figure>
                            <RoundTickIcon />
                          </figure>
                          <Box className="queryRight">
                            <Typography variant="body1">
                              Denied Videos
                            </Typography>
                            <Typography variant="caption">
                              {emptyHandleTwo(
                                managerCardSubmissionData?.data?.data.denied
                                  ?.total
                              )}
                            </Typography>
                          </Box>
                        </Stack>
                      </>
                    }
                    {...a11yProps(7)}
                    className="btndeniedVideo"
                  />
                  <Tab
                    // onClick={() => {
                    //   // setManagerVideoPage("1")
                    //   setManagerDecision("");
                    //   setQualityTeamDecision("");
                    //   setDuplicateStatus("yes");
                    // }}
                    onClick={() => filterReset()}
                    label={
                      <>
                        <Stack
                          direction={"row"}
                          alignItems={"center"}
                          flexWrap={"wrap"}
                          className="tabBtnWrapper"
                        >
                          <figure>
                            <DuplicateIcon />
                          </figure>
                          <Box className="queryRight">
                            <Typography variant="body1">
                              Duplicated Videos
                            </Typography>
                            <Typography variant="caption">
                              {emptyHandleTwo(
                                managerCardSubmissionData?.data?.data
                                  .all_submissions?.duplicate_videos
                              )}
                            </Typography>
                          </Box>
                        </Stack>
                      </>
                    }
                    {...a11yProps(8)}
                    className="btnduplicatedVideo"
                  />
                </Tabs>
              </Box>
              <Box className={styles.qcTable}>
                <TabPanel value={innerTab} index={0}>
                  <Paper
                    className={`${styles.tablePaper} ${styles.tableQCPaper} ${styles.tableManagerPaper}`}
                  >
                    {/* <ModaltableHeader
                        allVideo={false}
                        searchType={true}
                        pendingBtn={false}
                        filterBtn={true}
                      /> */}
                    {/* <Box className={styles.tableResponsive}> */}
                    {/* {isLoading2 ? (
                          <ApiLoader loading={isLoading2} />
                        ) : data?.data?.data.length >= 1 ? ( */}
                    <ManagersModalTable selectedId={props?.selectedId} />
                    {/* ) : (
                          <>
                            <EmptyTable
                              emptyTableText={
                                "All clear! No videos found under inquiry tab."
                              }
                            />
                          </>
                        )} */}
                    {/* <Box className={styles.innerPagination}>
                          <Pagination
                            lastpage={data?.data?.last_page}
                            onClick={undefined}
                            sendDataToParent={(page) =>
                              setManagerVideoPage(page)
                            }
                          />
                        </Box> */}
                    {/* </Box> */}
                  </Paper>
                </TabPanel>
                <TabPanel value={innerTab} index={1}>
                  <Box className="tabWrapper managerTabwrapper">
                    <Tabs
                      value={confimvdoTab}
                      onChange={handleChange4}
                      aria-label="basic tabs example"
                    >
                      <Tab
                        // onClick={() => {
                        //   setManagerDecision("1");
                        //   setQualityTeamDecision("1");
                        //   setManagerVideoPage("1");
                        // }}
                        onClick={() => {
                          filterReset();
                        }}
                        label={
                          <>
                            <span>Approved</span>
                            <TabArrowIcon />
                            <span>Approved</span>
                          </>
                        }
                        {...a11yProps(5)}
                      />
                      <Tab
                        // onClick={() => {
                        //   setManagerDecision("5");
                        //   setQualityTeamDecision("5");
                        //   setManagerVideoPage("1");
                        // }}
                        onClick={() => {
                          filterReset();
                        }}
                        label={
                          <>
                            <span>Website Only</span>
                            <TabArrowIcon />
                            <span>Website Only</span>
                          </>
                        }
                        {...a11yProps(6)}
                      />
                      <Tab
                        // onClick={() => {
                        //   setManagerDecision("2");
                        //   setQualityTeamDecision("2");
                        //   setManagerVideoPage("1");
                        // }}
                        onClick={() => {
                          filterReset();
                        }}
                        label={
                          <>
                            <span>Rejected</span>
                            <TabArrowIcon />
                            <span>Rejected</span>
                          </>
                        }
                        {...a11yProps(7)}
                      />
                    </Tabs>
                  </Box>
                  <Paper
                    className={`${styles.tablePaper} ${styles.tableQCPaper} ${styles.manConfrimPaper}`}
                  >
                    <TabPanel value={confimvdoTab} index={0}>
                      <ManagerConfirmedApprovedApprovedTable
                        selectedId={props?.selectedId}
                      />
                    </TabPanel>
                    <TabPanel value={confimvdoTab} index={1}>
                      <ManagerConfirmedWebsiteTable
                        selectedId={props?.selectedId}
                      />
                    </TabPanel>
                    <TabPanel value={confimvdoTab} index={2}>
                      <ManagerConfirmedRejectTable
                        selectedId={props?.selectedId}
                      />
                    </TabPanel>
                  </Paper>
                </TabPanel>
                <TabPanel value={innerTab} index={2}>
                  <Box className="tabWrapper deniedVideo managerTabwrapper">
                    <PerfectScrollbar>
                      <Tabs
                        value={deniedvdoTab}
                        onChange={handleChange5}
                        aria-label="basic tabs example"
                      >
                        <Tab
                          // onClick={() => {
                          //   setManagerVideoPage("1");
                          //   setManagerDecision("1");
                          //   setQualityTeamDecision("2");
                          // }}
                          onClick={() => filterReset()}
                          label={
                            <>
                              <span>Approved</span>
                              <TabArrowIcon />
                              <span>Rejected</span>
                            </>
                          }
                          {...a11yProps(8)}
                        />
                        <Tab
                          // onClick={() => {
                          //   setManagerVideoPage("1");
                          //   setManagerDecision("1");
                          //   setQualityTeamDecision("5");
                          // }}
                          onClick={() => filterReset()}
                          label={
                            <>
                              <span>Approved</span>
                              <TabArrowIcon />
                              <span>Website Only</span>
                            </>
                          }
                          {...a11yProps(9)}
                        />
                        <Tab
                          // onClick={() => {
                          //   setManagerVideoPage("1");
                          //   setManagerDecision("2");
                          //   setQualityTeamDecision("1");
                          // }}
                          onClick={() => filterReset()}
                          label={
                            <>
                              <span>Rejected</span>
                              <TabArrowIcon />
                              <span>Approved</span>
                            </>
                          }
                          {...a11yProps(10)}
                        />
                        <Tab
                          // onClick={() => {
                          //   setManagerVideoPage("1");
                          //   setManagerDecision("2");
                          //   setQualityTeamDecision("5");
                          // }}
                          onClick={() => filterReset()}
                          label={
                            <>
                              <span>Rejected</span>
                              <TabArrowIcon />
                              <span>Website Only</span>
                            </>
                          }
                          {...a11yProps(11)}
                        />
                        <Tab
                          // onClick={() => {
                          //   setManagerVideoPage("1");
                          //   setManagerDecision("5");
                          //   setQualityTeamDecision("1");
                          // }}
                          onClick={() => filterReset()}
                          label={
                            <>
                              <span>Website Only</span>
                              <TabArrowIcon />
                              <span>Approved</span>
                            </>
                          }
                          {...a11yProps(12)}
                        />
                        <Tab
                          // onClick={() => {
                          //   setManagerVideoPage("1");
                          //   setManagerDecision("5");
                          //   setQualityTeamDecision("2");
                          // }}
                          onClick={() => filterReset()}
                          label={
                            <>
                              <span>Website Only</span>
                              <TabArrowIcon />
                              <span>Rejected</span>
                            </>
                          }
                          {...a11yProps(13)}
                        />
                      </Tabs>
                    </PerfectScrollbar>
                  </Box>
                  <Paper
                    className={`${styles.tablePaper} ${styles.tableQCPaper} ${styles.manConfrimPaper}`}
                  >
                    <TabPanel value={deniedvdoTab} index={0}>
                      <ManagerDeniedApprovedRejectedTable
                        selectedId={props?.selectedId}
                      />
                    </TabPanel>
                    <TabPanel value={deniedvdoTab} index={1}>
                      <ManagerDeniedApprovedWebsiteTable
                        selectedId={props?.selectedId}
                      />
                    </TabPanel>
                    <TabPanel value={deniedvdoTab} index={2}>
                      <ManagerDeniedRejectedApprovedTable
                        selectedId={props?.selectedId}
                      />
                    </TabPanel>
                    <TabPanel value={deniedvdoTab} index={3}>
                      <ManagerDeniedRejectedWebsiteTable
                        selectedId={props?.selectedId}
                      />
                    </TabPanel>
                    <TabPanel value={deniedvdoTab} index={4}>
                      <ManagerDeniedWebsiteApprovedTable
                        selectedId={props?.selectedId}
                      />
                    </TabPanel>
                    <TabPanel value={deniedvdoTab} index={5}>
                      <ManagerDeniedWebsiteRejectedTable
                        selectedId={props?.selectedId}
                      />
                    </TabPanel>
                  </Paper>
                </TabPanel>
                <TabPanel value={innerTab} index={3}>
                  <Paper
                    className={`${styles.tablePaper} ${styles.tableQCPaper} ${styles.tableManagerPaper}`}
                  >
                    <ManagersDuplicateVideoTable
                      selectedId={props?.selectedId}
                    />
                  </Paper>
                </TabPanel>
              </Box>
            </Box>
          </TabPanel>
          <TabPanel value={value} index={2}>
            <Box className={`${styles.assignAccTab} ${styles.managerAccTab}`}>
              <Grid
                container
                rowSpacing={2}
                columnSpacing={{ xs: 1, sm: 2, md: 2, lg: 11.25 }}
              >
                <Grid item xs={12} md={6}>
                  <Paper className={styles.assignCard}>
                    <Stack
                      direction={"row"}
                      alignItems={"center"}
                      justifyContent={"space-between"}
                      flexWrap={"wrap"}
                      className={styles.assignCardHeader}
                    >
                      <Typography variant="h3">Assigned Accounts</Typography>

                      <Box>
                        {assignRadio?.length > 0 ? (
                          <>
                            <Button
                              className={styles.cancelBtn}
                              onClick={handleCancel}
                            >
                              Cancel
                            </Button>
                            <Button
                              className={styles.unassignBtn}
                              onClick={handleClick}
                            >
                              Unassign
                            </Button>
                          </>
                        ) : (
                          <Button className={styles.accBtn}>
                            Unassign Accounts
                          </Button>
                        )}
                      </Box>
                    </Stack>
                    <Box className={styles.innerCardgroup}>
                      <PerfectScrollbar>
                        <Grid container spacing={2.75}>
                          {assignUnassignList?.assigned_users?.map(
                            (cardItem) => {
                              return (
                                <Grid item md={6}>
                                  <AssignRadioCard
                                    src={cardItem?.src}
                                    type={cardItem?.status}
                                    title={`${cardItem?.name} ${
                                      cardItem?.last_name
                                        ? cardItem?.last_name
                                        : ""
                                    }`}
                                    email={cardItem?.email}
                                    link={cardItem?.link}
                                    subNumber={cardItem?.videos_count}
                                    assignText={cardItem?.assignText}
                                    greg={cardItem?.greg}
                                    gregName={cardItem?.gregName}
                                    gregTitle={cardItem?.gregTitle}
                                    assignType={"unassign"}
                                    id={cardItem?.id}
                                    avatar={cardItem?.avatar}
                                    getdata={getAssignData}
                                    setClicked={setClicked}
                                    clicked={clicked}
                                  />
                                </Grid>
                              );
                            }
                          )}
                        </Grid>
                      </PerfectScrollbar>
                      <Backdrop
                        open={snackOpen}
                        onClick={handleClose}
                        sx={{ zIndex: "11" }}
                      >
                        <Snackbar
                          open={snackOpen}
                          autoHideDuration={1000}
                          onClose={handleClose}
                          message={`Accounts Unassigned Successfully`}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "center",
                          }}
                          ContentProps={{
                            sx: {
                              justifyContent: "center",
                              minWidth: "289px !important",
                              background: "#000",
                              boxShadow: "0px 0px 3px 1px rgba(0, 0, 0, 0.5)",
                              height: "45px",
                              padding: 0,
                              "& .MuiSnackbarContent-message": {
                                fontWeight: "500",
                                fontSize: "13px",
                              },
                            },
                          }}
                        />
                      </Backdrop>
                    </Box>
                  </Paper>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Paper className={styles.assignCard}>
                    <Stack
                      direction={"row"}
                      alignItems={"center"}
                      justifyContent={"space-between"}
                      flexWrap={"wrap"}
                      className={styles.assignCardHeader}
                    >
                      <Typography variant="h3">Accounts to Assign</Typography>
                      {unassignRadio?.length > 0 ? (
                        <Box>
                          <Button
                            className={styles.cancelBtn}
                            onClick={handleCancel1}
                          >
                            Cancel
                          </Button>
                          <Button
                            className={styles.assignBtn}
                            onClick={handleClick1}
                          >
                            Assign
                          </Button>
                        </Box>
                      ) : (
                        ""
                      )}
                    </Stack>
                    <Box className={styles.innerCardgroup}>
                      <PerfectScrollbar>
                        <Grid container spacing={2.75}>
                          {assignUnassignList?.unassigned_users?.map(
                            (cardItem) => {
                              return (
                                <Grid item md={6}>
                                  <AssignRadioCard
                                    src={cardItem?.src}
                                    type={cardItem?.status}
                                    title={`${cardItem?.name} ${
                                      cardItem?.last_name
                                        ? cardItem?.last_name
                                        : ""
                                    }`}
                                    email={cardItem?.email}
                                    link={cardItem?.link}
                                    subNumber={cardItem?.videos_count}
                                    assignText={cardItem?.assignText}
                                    greg={cardItem?.greg}
                                    gregName={cardItem?.gregName}
                                    gregTitle={cardItem?.gregTitle}
                                    assignType={"assign"}
                                    id={cardItem?.id}
                                    getdata={getUnassignData}
                                    avatar={cardItem?.avatar}
                                    setClicked={setClicked}
                                    clicked={clicked}
                                  />
                                </Grid>
                              );
                            }
                          )}
                        </Grid>
                      </PerfectScrollbar>
                      <Backdrop
                        open={snackOpen1}
                        onClick={handleClose1}
                        sx={{ zIndex: "11" }}
                      >
                        <Snackbar
                          open={snackOpen1}
                          autoHideDuration={1000}
                          onClose={handleClose1}
                          message={`Accounts Assigned Successfully`}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "center",
                          }}
                          ContentProps={{
                            sx: {
                              justifyContent: "center",
                              minWidth: "289px !important",
                              background: "#000",
                              boxShadow: "0px 0px 3px 1px rgba(0, 0, 0, 0.5)",
                              height: "45px",
                              padding: 0,
                              "& .MuiSnackbarContent-message": {
                                fontWeight: "500",
                                fontSize: "13px",
                              },
                            },
                          }}
                        />
                      </Backdrop>
                    </Box>
                  </Paper>
                </Grid>
              </Grid>
            </Box>
          </TabPanel>
          <TabPanel value={value} index={3}>
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              className={`${styles.editorBody} ${styles.modalEditorBody} ${styles.onlyForPxModal}`}
            >
              <Box className={styles.SecFilter}>
                <NotificationLeftFilter
                  filterType={"manager"}
                  getDataFromChild={getDataFromChild}
                />
              </Box>
              <Box
                className={`${styles.analyticsBoxes} ${styles.boxTable} ${styles.managerAnalyticsBox}`}
              >
                <Box className={styles.inneranalytics}>
                  <Grid
                    container
                    rowSpacing={0}
                    columnSpacing={{ xs: 1, sm: 2, md: 6.25 }}
                  >
                    <Grid item md={6}>
                      <VideosummaryCardPartner
                        videoTitle={"Reviewing Summary"}
                        countVideo={""}
                      >
                        <List>
                          {/* {managerAnalyticsLoop.map((subItem) => {
                              return ( */}
                          {/* <ListItem>
                                  <Typography variant="body1">
                                    {subItem?.listName}
                                  </Typography>
                                  <Typography variant="caption">
                                    {subItem?.videoCount}
                                  </Typography>
                                </ListItem> */}
                          <ListItem>
                            <Typography variant="body1">
                              All videos
                              {/* {subItem?.listName} */}
                            </Typography>
                            <Typography variant="caption">
                              {emptyHandleTwo(
                                managerCardSubmissionData?.data?.data
                                  ?.all_submissions?.total
                              )}
                              {/* {subItem?.videoCount} */}
                            </Typography>
                          </ListItem>
                          <ListItem>
                            <Typography variant="body1">
                              Website-only videos
                            </Typography>
                            <Typography variant="caption">
                              {emptyHandleTwo(
                                managerCardSubmissionData?.data?.data
                                  ?.all_submissions?.website_only
                              )}
                            </Typography>
                          </ListItem>

                          <ListItem>
                            <Typography variant="body1">
                              All-platform videos
                            </Typography>
                            <Typography variant="caption">
                              {emptyHandleTwo(
                                managerCardSubmissionData?.data?.data
                                  ?.all_submissions?.approved
                              )}
                            </Typography>
                          </ListItem>
                          <ListItem>
                            <Typography variant="body1">
                              Duplicate videos
                            </Typography>
                            <Typography variant="caption">
                              {emptyHandleTwo(
                                managerCardSubmissionData?.data?.data
                                  ?.all_submissions?.duplicate_videos
                              )}
                            </Typography>
                          </ListItem>
                          <ListItem>
                            <Typography variant="body1">
                              Rejected videos
                            </Typography>
                            <Typography variant="caption">
                              {emptyHandleTwo(
                                managerCardSubmissionData?.data?.data
                                  ?.all_submissions?.rejected
                              )}
                            </Typography>
                          </ListItem>
                          {/* );
                            })} */}
                        </List>
                      </VideosummaryCardPartner>
                    </Grid>
                    <Grid item md={6}>
                      <VideosummaryCardPartner
                        videoTitle={"Validation Summary"}
                        countVideo={""}
                      >
                        {/* {analyticsValidsumLoop.map((item) => {
                            return (
                              <Box className={styles.videoTableRow}>
                                <Typography
                                  variant="h5"
                                  className={styles.vdoHead}
                                >
                                  {item?.videoTitle}{" "}
                                  <span>{item?.countVideo}</span>
                                </Typography>
                                <TableContainer>
                                  <Table>
                                    <TableBody>
                                      {item.children.map((subItem) => {
                                        return (
                                          <TableRow>
                                            <TableCell className={styles.tdOne}>
                                              <Typography variant="body1">
                                                {subItem?.listName}
                                              </Typography>
                                            </TableCell>
                                            <TableCell className={styles.tdTwo}>
                                              <LongArrowIcon />
                                            </TableCell>
                                            <TableCell
                                              className={styles.tdThree}
                                            >
                                              <Typography variant="body1">
                                                {subItem?.listname2}
                                              </Typography>
                                            </TableCell>
                                            <TableCell
                                              align="right"
                                              className={styles.tdFour}
                                            >
                                              <Typography variant="caption">
                                                {subItem?.videoCount}
                                              </Typography>
                                            </TableCell>
                                          </TableRow>
                                        );
                                      })}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </Box>
                            );
                          })} */}
                        <Box className={styles.videoTableRow}>
                          <Typography variant="h5" className={styles.vdoHead}>
                            {"Confirmed"}
                            <span>
                              {emptyHandleTwo(
                                managerCardSubmissionData?.data?.data
                                  ?.confirmed_videos?.total
                              )}
                            </span>
                          </Typography>
                          <TableContainer>
                            <Table>
                              <TableBody>
                                {/* {item.children.map((subItem) => {
                                        return ( */}
                                <TableRow>
                                  <TableCell className={styles.tdOne}>
                                    <Typography variant="body1">
                                      {/* {subItem?.listName} */}
                                      Approved
                                    </Typography>
                                  </TableCell>
                                  <TableCell className={styles.tdTwo}>
                                    <LongArrowIcon />
                                  </TableCell>
                                  <TableCell className={styles.tdThree}>
                                    <Typography variant="body1">
                                      {/* {subItem?.listname2} */}
                                      Approved
                                    </Typography>
                                  </TableCell>
                                  <TableCell
                                    align="right"
                                    className={styles.tdFour}
                                  >
                                    <Typography variant="caption">
                                      {/* {subItem?.videoCount} */}
                                      {emptyHandleTwo(
                                        managerCardSubmissionData?.data?.data
                                          ?.confirmed_videos?.approved_approved
                                      )}
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell className={styles.tdOne}>
                                    <Typography variant="body1">
                                      Website Only
                                    </Typography>
                                  </TableCell>
                                  <TableCell className={styles.tdTwo}>
                                    <LongArrowIcon />
                                  </TableCell>
                                  <TableCell className={styles.tdThree}>
                                    <Typography variant="body1">
                                      Website Only
                                    </Typography>
                                  </TableCell>
                                  <TableCell
                                    align="right"
                                    className={styles.tdFour}
                                  >
                                    <Typography variant="caption">
                                      {emptyHandleTwo(
                                        managerCardSubmissionData?.data?.data
                                          ?.confirmed_videos?.website_website
                                      )}
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell className={styles.tdOne}>
                                    <Typography variant="body1">
                                      {/* {subItem?.listName} */}
                                      Rejected
                                    </Typography>
                                  </TableCell>
                                  <TableCell className={styles.tdTwo}>
                                    <LongArrowIcon />
                                  </TableCell>
                                  <TableCell className={styles.tdThree}>
                                    <Typography variant="body1">
                                      {/* {subItem?.listname2} */}
                                      Rejected
                                    </Typography>
                                  </TableCell>
                                  <TableCell
                                    align="right"
                                    className={styles.tdFour}
                                  >
                                    <Typography variant="caption">
                                      {/* {subItem?.videoCount} */}
                                      {emptyHandleTwo(
                                        managerCardSubmissionData?.data?.data
                                          ?.confirmed_videos?.rejected_rejected
                                      )}
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                                {/* );
                                      })} */}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Box>
                        <Box className={styles.videoTableRow}>
                          <Typography variant="h5" className={styles.vdoHead}>
                            {"Denied"}
                            <span>
                              {emptyHandleTwo(
                                managerCardSubmissionData?.data?.data?.denied
                                  ?.total
                              )}
                            </span>
                          </Typography>
                          <TableContainer>
                            <Table>
                              <TableBody>
                                {/* {item.children.map((subItem) => {
                                        return ( */}
                                <TableRow>
                                  <TableCell className={styles.tdOne}>
                                    <Typography variant="body1">
                                      {/* {subItem?.listName} */}
                                      Approved
                                    </Typography>
                                  </TableCell>
                                  <TableCell className={styles.tdTwo}>
                                    <LongArrowIcon />
                                  </TableCell>
                                  <TableCell className={styles.tdThree}>
                                    <Typography variant="body1">
                                      {/* {subItem?.listname2} */}
                                      Rejected
                                    </Typography>
                                  </TableCell>
                                  <TableCell
                                    align="right"
                                    className={styles.tdFour}
                                  >
                                    <Typography variant="caption">
                                      {/* {subItem?.videoCount} */}
                                      {emptyHandleTwo(
                                        managerCardSubmissionData?.data?.data
                                          ?.denied?.approved_rejected
                                      )}
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell className={styles.tdOne}>
                                    <Typography variant="body1">
                                      Approved
                                    </Typography>
                                  </TableCell>
                                  <TableCell className={styles.tdTwo}>
                                    <LongArrowIcon />
                                  </TableCell>
                                  <TableCell className={styles.tdThree}>
                                    <Typography variant="body1">
                                      Website Only
                                    </Typography>
                                  </TableCell>
                                  <TableCell
                                    align="right"
                                    className={styles.tdFour}
                                  >
                                    <Typography variant="caption">
                                      {emptyHandleTwo(
                                        managerCardSubmissionData?.data?.data
                                          ?.denied?.approved_website
                                      )}
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell className={styles.tdOne}>
                                    <Typography variant="body1">
                                      Rejected
                                    </Typography>
                                  </TableCell>
                                  <TableCell className={styles.tdTwo}>
                                    <LongArrowIcon />
                                  </TableCell>
                                  <TableCell className={styles.tdThree}>
                                    <Typography variant="body1">
                                      Approved
                                    </Typography>
                                  </TableCell>
                                  <TableCell
                                    align="right"
                                    className={styles.tdFour}
                                  >
                                    <Typography variant="caption">
                                      {emptyHandleTwo(
                                        managerCardSubmissionData?.data?.data
                                          ?.denied?.rejected_approved
                                      )}
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell className={styles.tdOne}>
                                    <Typography variant="body1">
                                      Rejected
                                    </Typography>
                                  </TableCell>
                                  <TableCell className={styles.tdTwo}>
                                    <LongArrowIcon />
                                  </TableCell>
                                  <TableCell className={styles.tdThree}>
                                    <Typography variant="body1">
                                      Website Only
                                    </Typography>
                                  </TableCell>
                                  <TableCell
                                    align="right"
                                    className={styles.tdFour}
                                  >
                                    <Typography variant="caption">
                                      {emptyHandleTwo(
                                        managerCardSubmissionData?.data?.data
                                          ?.denied?.rejected_website
                                      )}
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell className={styles.tdOne}>
                                    <Typography variant="body1">
                                      Website Only
                                    </Typography>
                                  </TableCell>
                                  <TableCell className={styles.tdTwo}>
                                    <LongArrowIcon />
                                  </TableCell>
                                  <TableCell className={styles.tdThree}>
                                    <Typography variant="body1">
                                      Approved
                                    </Typography>
                                  </TableCell>
                                  <TableCell
                                    align="right"
                                    className={styles.tdFour}
                                  >
                                    <Typography variant="caption">
                                      {emptyHandleTwo(
                                        managerCardSubmissionData?.data?.data
                                          ?.denied?.website_approved
                                      )}
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell className={styles.tdOne}>
                                    <Typography variant="body1">
                                      Website Only
                                    </Typography>
                                  </TableCell>
                                  <TableCell className={styles.tdTwo}>
                                    <LongArrowIcon />
                                  </TableCell>
                                  <TableCell className={styles.tdThree}>
                                    <Typography variant="body1">
                                      Rejected
                                    </Typography>
                                  </TableCell>
                                  <TableCell
                                    align="right"
                                    className={styles.tdFour}
                                  >
                                    <Typography variant="caption">
                                      {emptyHandleTwo(
                                        managerCardSubmissionData?.data?.data
                                          ?.denied?.website_rejected
                                      )}
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                                {/* );
                                      })} */}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Box>
                      </VideosummaryCardPartner>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            </Stack>
          </TabPanel>
          <TabPanel value={value} index={4}>
            <Stack direction={"row"} className={styles.editorProfileTab}>
              <Box className={styles.PfsecLeft}>
                <ManagerUserCreateTab
                  userdata={{ id: props?.selectedId }} // forgotTitle={"Manager Forgot his Password?"}
                  forgotText={"for_manager"}
                  accountSubmission={false} // lastActive={true}
                />
              </Box>
              <Box className={styles.pfSecRight}>
                <Grid item md={6}>
                  {/* <VideosummaryCardPartner
                            videoTitle={""}
                            countVideo={""}
                          > */}
                  {/* <List> */}
                  {/* {item.children.map((subItem) => {
                                return ( */}
                  {/* <ListItem> */}
                  {/* <Typography variant="body1"> */}
                  <TipaltiPartnerCard userdata={{ status: props?.type }} />
                  {/* </Typography> */}
                  {/* </ListItem> */}
                  {/* )})}  */}
                  {/* </List> */}
                  {/* </VideosummaryCardPartner> */}
                </Grid>
              </Box>
            </Stack>
          </TabPanel>
          {/* </PerfectScrollbar> */}
        </Box>
      </EditorsLargeModal>
    </>
  );
};

export default ManagerCard;
